/**
 * Repository configs used with protobuf
 */

export const AUTH_SERVICE_URL = `auth.api.v2.dungulie.com:7878`;
export const QUERY_SERVICE_URL = "query.v1.dev.api.hurryup.co:10001";
export const CORE_SERVICE_URL = "core.v1.dev.api.hurryup.co:10000";
